<template>
    <div>
        <el-card style='margin-top: 2rem;' class='box-card'>
            <div slot='header' class='clearfix'>
                <h3>{{ $t('account.phone') || '手机号' }}</h3>
            </div>
            <!-- 换绑手机号 -->
            <div v-if='updatePhoneStatus && userInfo.phone'>
                <div v-if='!captchaInfo.verifyStatus'>
                    <el-form label-position='left' ref='changeMyPhone' :rules='rules' :model='captchaInfo'
                             label-width='80px'>
                        <el-form-item :label="$t('login.verifyCode') || '验证码'" prop='captcha'>
                            <el-input type='number' v-model='captchaInfo.captcha' style='width: 50%'
                                      :placeholder="$t('account.enterVerifyCode') || '请输验证码'" />
                            &nbsp;&nbsp;<el-button type='text' :disabled='captchaInfo.sendCaptchaStatus'
                                                   @click='sendPhoneCaptchaByAccount'>
                            {{ captchaInfo.sendCaptchaStatus ? `${captchaInfo.resendTime}${$t('login.resendAfterSend') || '秒后重新发送'}` : $t('login.sendVerifyCode') || '发送验证码'
                            }}
                        </el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type='primary' size='mini' @click='verifyCaptcha'>{{ $t('common.verify') || '验证'
                                }}
                            </el-button>
                            <el-button type='info' size='mini' @click='closePhoneUpdate'>{{ $t('common.close') || '关闭'
                                }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-if='captchaInfo.verifyStatus'>
                    <el-form label-position='left' ref='changeMyPhone' :rules='rules' :model='captchaInfo'
                             label-width='80px'>
                        <el-form-item :label="$t('account.newPhone') || '新手机号'" key='phone' prop='phone'>
                            <el-input type='number' v-model='captchaInfo.phone'
                                      :placeholder="$t('account.enterNewPhone') || '请输入新手机号'" />
                        </el-form-item>
                        <el-form-item :label="$t('login.verifyCode') || '验证码'" key='captcha'>
                            <el-input type='number' v-model='captchaInfo.captcha' style='width: 50%'
                                      :placeholder="$t('login.enterVerifyCode') || '请输入验证码'" />
                            &nbsp;&nbsp;<el-button type='text' :disabled='captchaInfo.sendCaptchaStatus'
                                                   @click='sendCaptchaByPhone("changeMyPhone")'>
                            {{ captchaInfo.sendCaptchaStatus ? `${captchaInfo.resendTime}${$t('login.resendAfterSend') || '秒后重新发送'}` : $t('login.sendVerifyCode') || '发送验证码'
                            }}
                        </el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button :disabled='!captchaInfo.sendCaptchaStatus' type='primary' size='mini'
                                       @click='updateOrAddPhone("changeMyPhone")'>{{ $t('common.confirm') || '确定' }}
                            </el-button>
                            <el-button type='info' size='mini' @click='closePhoneUpdate'>{{ $t('common.close') || '关闭'
                                }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            
            <!-- 添加手机号 -->
            <div v-if='updatePhoneStatus && !userInfo.phone'>
                <el-form label-position='left' ref='addNewPhone' :rules='rules' :model='captchaInfo' label-width='80px'>
                    <el-form-item :label="$t('account.phone') || '手机号'" key='phone' prop='phone'>
                        <el-input type='number' v-model='captchaInfo.phone'
                                  :placeholder="$t('account.enterPhone') || '请输入手机号'" />
                    </el-form-item>
                    <el-form-item :label="$t('login.verifyCode') || '验证码'" key='captcha'>
                        <el-input type='number' v-model='captchaInfo.captcha' style='width: 50%'
                                  :placeholder="$t('login.enterVerifyCode') || '请输入验证码'" />
                        &nbsp;&nbsp;<el-button type='text' :disabled='captchaInfo.sendCaptchaStatus'
                                               @click='sendCaptchaByPhone("addNewPhone")'>
                        {{ captchaInfo.sendCaptchaStatus ? `${captchaInfo.resendTime}${$t('login.resendAfterSend') || '秒后重新发送'}` : $t('login.sendVerifyCode') || '发送验证码'
                        }}
                    </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type='primary' size='mini' @click='updateOrAddPhone("addNewPhone")'>
                            {{ $t('common.confirm') || '确定' }}
                        </el-button>
                        <el-button type='info' size='mini' @click='closePhoneUpdate'>{{ $t('common.close') || '关闭'
                            }}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
            
            <!--展示手机号-->
            <el-form v-if='!updatePhoneStatus' label-position='left' inline>
                <el-form-item :label="$t('account.phone') || '手机号'" prop='age'>
                    <p>{{ userInfo.phone }}</p>
                </el-form-item>
                <el-form-item>
                    <el-button @click='updatePhoneStatus = true' type='text'>
                        {{ userInfo.phone ? ($t('common.unbind') || '换绑') : ($t('common.bind') || '绑定') }}
                    </el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { message } from '@/utils/message';
import { accountApi } from '@/service/api/accountApi';

export default defineComponent({
    name: 'AddOrUpdatePhone',
    props: {
        userInfo: {
            type: Object
        }
    },
    data() {
        return {
            updatePhoneStatus: false,
            captchaInfo: {
                captcha: '',
                resendTime: 60,
                phone: undefined,
                verifyStatus: false,
                sendCaptchaStatus: false
            },
            rules: {
                phone: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error(this.$t('account.enterPhone') || '请输入手机号'));
                            } else {
                                callback();
                            }
                        }
                    }
                ],
                captcha: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error(this.$t('login.enterVerifyCode') || '请输入验证码'));
                            } else {
                                callback();
                            }
                        }
                    }
                ]
            },
            time: undefined
        };
    },
    created() {
    },
    methods: {
        sendCaptchaByPhone(formName) {
            if (this.captchaInfo.sendCaptchaStatus) {
                return;
            }
            this.$refs[formName].validate(valid => {
                if (!valid) {
                    return false;
                }
                accountApi.sendCaptchaByPhone({ phone: this.captchaInfo.phone }).then(result => {
                    if (result.code === 200) {
                        this.captchaInfo.sendCaptchaStatus = true;
                        this.time = setInterval(() => {
                            if (this.captchaInfo.resendTime <= 1) {
                                clearInterval(this.time);
                                this.captchaInfo.resendTime = 60;
                                this.captchaInfo.sendCaptchaStatus = false;
                            } else {
                                this.captchaInfo.resendTime = this.captchaInfo.resendTime - 1;
                            }
                        }, 1000);
                        message.success(this.$t('account.codeSentCheckPhone') || '验证码已发送，请检查手机号');
                    }
                });
            });
        },
        updateOrAddPhone(formName) {
            this.$refs[formName].validate(valid => {
                if (!valid) {
                    return false;
                }
                accountApi.updateOrAddPhone({
                    userId: this.userInfo.userId,
                    phone: this.captchaInfo.phone,
                    captcha: this.captchaInfo.captcha
                }).then(result => {
                    if (result.code === 200) {
                        if (this.time) {
                            clearInterval(this.time);
                        }
                        this.updatePhoneStatus = false;
                        this.userInfo.phone = this.captchaInfo.phone;
                        this.resetCaptchaInfo();
                        if (this.userInfo.phone) {
                            message.success(this.$t('account.unbindSuccess') || '换绑成功');
                        } else {
                            message.success(this.$t('account.bindSuccess') || '绑定成功');
                        }
                    }
                });
            });
        },
        sendPhoneCaptchaByAccount() {
            accountApi.sendPhoneCaptchaByAccount({ account: this.userInfo.account }).then(result => {
                if (result.code === 200) {
                    message.success(this.$t('account.codeSentCheckBoundPhone') || '验证码已发送，请检查该账号绑定的手机号');
                    this.captchaInfo.sendCaptchaStatus = true;
                    this.time = setInterval(() => {
                        if (this.captchaInfo.resendTime <= 1) {
                            clearInterval(this.time);
                            this.captchaInfo.resendTime = 60;
                            this.captchaInfo.sendCaptchaStatus = false;
                        } else {
                            this.captchaInfo.resendTime = this.captchaInfo.resendTime - 1;
                        }
                    }, 1000);
                }
            });
        },
        verifyCaptcha() {
            if (!this.captchaInfo.captcha) {
                message.error(this.$t('login.enterVerifyCode') || '请输入验证码');
                return;
            }
            accountApi.checkPhoneCaptcha({
                phone: this.userInfo.phone,
                captcha: this.captchaInfo.captcha
            }).then(result => {
                if (result.code === 200) {
                    if (this.time) {
                        clearInterval(this.time);
                    }
                    this.captchaInfo.captcha = undefined;
                    this.captchaInfo.phone = undefined;
                    this.captchaInfo.verifyStatus = true;
                    this.captchaInfo.sendCaptchaStatus = false;
                    this.captchaInfo.resendTime = 60;
                }
            });
        },
        closePhoneUpdate() {
            clearInterval(this.time);
            this.updatePhoneStatus = false;
            this.resetCaptchaInfo();
        },
        resetCaptchaInfo() {
            this.captchaInfo = {
                captcha: '',
                resendTime: 60,
                phone: undefined,
                verifyStatus: false,
                sendCaptchaStatus: false
            };
        }
    }
});
</script>

<style scoped lang='css'>
.account-input {
    width: 40%;
}
</style>
